import { FC } from "react";
import { Main, Container, IconWrapper, Title, Message } from "./style";
import { SettingsSvg } from "assets/images/common/svgs";

interface Props {
  text: string;
}

const MaintenanceModal: FC<Props> = ({ text }) => {
  return (
    <Main>
      <Container>
        <IconWrapper>
          <SettingsSvg />
        </IconWrapper>
        <Title>System Under Maintenance</Title>
        <Message>{text}</Message>
      </Container>
    </Main>
  );
};

export default MaintenanceModal;
